import { Main } from 'layouts';
import React from 'react';
import { CollectionDetailView } from 'views';
import WithLayout from 'WithLayout';

export default function CollectionDetailPage ({ collection, creator }: ViewComponentProps): JSX.Element {
    return <WithLayout component={CollectionDetailView} layout={Main} collection={collection} creator={creator} />;
}